import React from "react";
import { HomeGrid } from "../styles/Grids";
import styled from "styled-components";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import Container from "../styles/Container";
import { theme } from "../styles/theme";
import { FaArrowRight } from "react-icons/fa";

const HomeHeroWrapper = styled.div`
  background: var(--grey);
  padding: 12rem 0;
`;
const HeroTitle = styled.h1`
  font-size: clamp(2em, 10vw, 6em);
  font-weight: 900;

  background: conic-gradient(
    from 0.25turn at 50% 30%,
    var(--lightblue),
    10deg,
    var(--blue),
    350deg,
    var(--lightblue)
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  span {
    color: var(--lightblue);
  }
`;

const BtnWrap = styled.div`
  display: flex;
  margin-top: 2rem;
`;
const Button = styled(Link)`
  font-family: "Roboto";
  background: var(--white);
  padding: 1.5rem 3rem;
  border-radius: 0.7rem;
  font-size: 1.8rem;
  font-weight: 200;
  color: var(--blue);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.3s !important;

  box-shadow: ${theme.shadow.blue};

  &:nth-child(2) {
    margin-left: 2rem;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${theme.shadow.blue_mo};
  }
`;

const Arrow = styled(FaArrowRight)`
  margin-left: 1rem;
`;
const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center; ;
`;
const ImageBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  .hero-img {
    margin-bottom: -25rem;
    border-radius: 0.7rem;
    box-shadow: ${theme.shadow.feature.big.default};
  }
`;

const fadeLeft = {
  hidden: { opacity: 0, x: -100 },
  visible: { opacity: 1, x: 0 },
};
const fadeRight = {
  hidden: { opacity: 0, x: 100 },
  visible: { opacity: 1, x: 0 },
};
export default function HomeHero() {
  return (
    <HomeHeroWrapper>
      <Container>
        <HomeGrid>
          <TextBox>
            <HeroTitle>
              Pure pressure <span>mobile wash</span>
            </HeroTitle>
            <BtnWrap>
              <Button>
                Learn more <Arrow />
              </Button>
              <Button>
                {" "}
                Contact Us <Arrow />
              </Button>
            </BtnWrap>
          </TextBox>
          <ImageBox>
            <StaticImage
              src="../assets/images/hero-img.jpg"
              alt="pure pressure home"
              className="hero-img"
            />
          </ImageBox>
        </HomeGrid>
      </Container>
    </HomeHeroWrapper>
  );
}
